// src/pages/KitchenDisplay.js — FIXED
// Only shows PENDING, PREPARING, READY (NOT AWAITING_PAYMENT)
// order:new socket fires ONLY after payment confirmed
import React, { useState, useEffect, useCallback } from 'react';
import { getOrders, updateOrderStatus } from '../services/api';
import { connectSocket } from '../services/socket';
import { useAuth } from '../context/AuthContext';

const URGENT_MS = 10 * 60 * 1000;

function elapsed(createdAt) {
  const d = Date.now() - new Date(createdAt).getTime();
  return { d, label: `${Math.floor(d/60000)}:${String(Math.floor((d%60000)/1000)).padStart(2,'0')}` };
}

function OrderCard({ order, onAdvance }) {
  const [el, setEl] = useState(elapsed(order.createdAt));
  useEffect(() => { const t = setInterval(() => setEl(elapsed(order.createdAt)), 1000); return () => clearInterval(t); }, [order.createdAt]);

  const urgent = el.d > URGENT_MS;
  const col = { PENDING:{bg:'#2d1f00',border:'#f5a623',text:'#f5a623',lbl:'NEW'}, PREPARING:{bg:'#1a2d1a',border:'#4caf7d',text:'#4caf7d',lbl:'COOKING'}, READY:{bg:'#1a1a3d',border:'#5a9fe0',text:'#5a9fe0',lbl:'READY'} }[order.status] || {bg:'#1a1a1a',border:'#333',text:'#888',lbl:order.status};
  const nextLbl = order.status==='PENDING' ? '→ Start Cooking' : order.status==='PREPARING' ? '✓ Mark Ready' : null;

  return (
    <div style={{ background:col.bg, border:`2px solid ${urgent?'#e05a5a':col.border}`, borderRadius:16, padding:20, display:'flex', flexDirection:'column', gap:12, position:'relative' }}>
      {urgent && <div style={{ position:'absolute', top:0, left:0, right:0, background:'#e05a5a', color:'#fff', fontSize:11, fontWeight:700, textAlign:'center', padding:'4px 0', borderRadius:'14px 14px 0 0' }}>⚠ URGENT — {Math.floor(el.d/60000)} MINS</div>}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginTop:urgent?20:0 }}>
        <div>
          <div style={{ fontSize:22, fontWeight:700, color:col.text }}>{order.orderNumber}</div>
          {order.tableNo && <div style={{ fontSize:13, color:'#888', marginTop:2 }}>🪑 Table {order.tableNo}</div>}
        </div>
        <div style={{ textAlign:'right' }}>
          <div style={{ fontSize:11, fontWeight:700, color:col.text, padding:'4px 10px', background:col.border+'22', borderRadius:20 }}>{col.lbl}</div>
          <div style={{ fontSize:20, fontWeight:700, marginTop:6, color:urgent?'#e05a5a':'#888' }}>{el.label}</div>
        </div>
      </div>
      <div style={{ borderTop:`1px solid ${col.border}44`, paddingTop:12 }}>
        {order.items?.map((item, i) => (
          <div key={i} style={{ display:'flex', alignItems:'center', marginBottom:8 }}>
            <span style={{ fontSize:26, fontWeight:700, color:col.text, marginRight:10 }}>×{item.quantity||item.qty}</span>
            <div>
              <div style={{ fontSize:15, fontWeight:600 }}>{item.name}</div>
              {item.modifierNote && <div style={{ fontSize:12, color:'#f5a623' }}>📝 {item.modifierNote}</div>}
            </div>
          </div>
        ))}
      </div>
      {order.notes && <div style={{ background:'#3d2e10', borderRadius:8, padding:'8px 12px', fontSize:13, color:'#f5a623' }}>📝 {order.notes}</div>}
      {nextLbl && (
        <button onClick={() => onAdvance(order)} style={{ width:'100%', padding:'13px 0', background:col.border, color:'#000', border:'none', borderRadius:10, fontSize:15, fontWeight:700, cursor:'pointer' }}>
          {nextLbl}
        </button>
      )}
    </div>
  );
}

export default function KitchenDisplay() {
  const { vendor } = useAuth();
  const [cols,      setCols]      = useState({ PENDING:[], PREPARING:[], READY:[] });
  const [clock,     setClock]     = useState(new Date());
  const [connected, setConnected] = useState(false);

  const group = useCallback((list) => {
    const g = { PENDING:[], PREPARING:[], READY:[] };
    list.forEach((o) => { if (g[o.status]) g[o.status].push(o); });
    return g;
  }, []);

  useEffect(() => { const t = setInterval(() => setClock(new Date()), 1000); return () => clearInterval(t); }, []);

  // useEffect(() => {
  //   if (!vendor?.id) return;
  //   // Load only paid orders (PENDING, PREPARING, READY)
  //   Promise.all([
  //     getOrders({ vendorId: vendor.id, status: 'PENDING'   }),
  //     getOrders({ vendorId: vendor.id, status: 'PREPARING' }),
  //     getOrders({ vendorId: vendor.id, status: 'READY'     }),
  //   ]).then(([a, b, c]) => setCols(group([...a.data, ...b.data, ...c.data]))).catch(() => {});
  // }, [vendor, group]);

  // useEffect(() => {
  //   if (!vendor?.id) return;
  //   const socket = connectSocket(vendor.id);
  //   setConnected(true);

  //   // order:new fires ONLY after payment — kitchen sees it here
  //   socket.on('order:new', (order) => {
  //     if (!['PENDING','PREPARING','READY'].includes(order.status)) return;
  //     setCols((prev) => {
  //       const all = Object.values(prev).flat().filter((o) => o.id !== order.id);
  //       return group([...all, order]);
  //     });
  //     playAlert();
  //   });

  //   socket.on('order:status', ({ id, status }) => {
  //     setCols((prev) => {
  //       const all = Object.values(prev).flat().map((o) => o.id===id ? {...o,status} : o);
  //       return group(all.filter((o) => ['PENDING','PREPARING','READY'].includes(o.status)));
  //     });
  //   });

  //   return () => { socket.off('order:new'); socket.off('order:status'); };
  // }, [vendor, group]);
      const fetchAll = useCallback(() => {
    if (!vendor?.id) return;
    Promise.all([
      getOrders({ vendorId: vendor.id, status: 'PENDING'   }),
      getOrders({ vendorId: vendor.id, status: 'PREPARING' }),
      getOrders({ vendorId: vendor.id, status: 'READY'     }),
    ]).then(([a, b, c]) => setCols(group([...a.data, ...b.data, ...c.data]))).catch(() => {});
  }, [vendor, group]);

  // Initial load + 15-second poll fallback (catches socket drops & completed order removal)
  useEffect(() => {
    fetchAll();
    const t = setInterval(fetchAll, 15000);
    return () => clearInterval(t);
  }, [fetchAll]);

  useEffect(() => {
    if (!vendor?.id) return;
    const socket = connectSocket(vendor.id);
    setConnected(true);

    socket.on('order:new', (order) => {
      if (!['PENDING','PREPARING','READY'].includes(order.status)) return;
      setCols((prev) => {
        const all = Object.values(prev).flat().filter((o) => o.id !== order.id);
        return group([...all, order]);
      });
      playAlert();
    });

    socket.on('order:status', ({ id, status }) => {
      setCols((prev) => {
        const all = Object.values(prev).flat().map((o) => o.id===id ? {...o,status} : o);
        return group(all.filter((o) => ['PENDING','PREPARING','READY'].includes(o.status)));
      });
    });

    // Reconnect: re-fetch to catch any missed events
    socket.on('connect', () => { setConnected(true); fetchAll(); });
    socket.on('disconnect', () => setConnected(false));

    return () => {
      socket.off('order:new');
      socket.off('order:status');
      socket.off('connect');
      socket.off('disconnect');
    };
  }, [vendor, group, fetchAll]);
  
  const playAlert = () => {
    try {
      const ctx = new (window.AudioContext||window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const g   = ctx.createGain();
      osc.connect(g); g.connect(ctx.destination);
      osc.frequency.value = 880;
      g.gain.setValueAtTime(0.3, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
      osc.start(); osc.stop(ctx.currentTime + 0.5);
    } catch (_) {}
  };

  const advance = async (order) => {
    const next = { PENDING:'PREPARING', PREPARING:'READY' }[order.status];
    if (!next) return;
    try { await updateOrderStatus(order.id, next); } catch (_) {}
    setCols((prev) => {
      const all = Object.values(prev).flat().map((o) => o.id===order.id ? {...o,status:next} : o);
      return group(all);
    });
  };

  const active = cols.PENDING.length + cols.PREPARING.length;

  return (
    <div style={{ minHeight:'100vh', background:'#0a0a0a', color:'#f0ede8', fontFamily:"'Segoe UI',system-ui,sans-serif", display:'flex', flexDirection:'column' }}>
      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 24px', background:'#111', borderBottom:'1px solid #222' }}>
        <div style={{ display:'flex', alignItems:'center', gap:14 }}>
          <div style={{ fontSize:20, fontWeight:700, color:'#f5a623' }}>⚡ Kitchen Display</div>
          <div style={{ fontSize:12, padding:'4px 10px', borderRadius:20, background:connected?'#1a3d2a':'#3d1a1a', color:connected?'#4caf7d':'#e05a5a' }}>
            {connected ? '● Live' : '○ Connecting'}
          </div>
          <div style={{ fontSize:11, color:'#444', padding:'3px 8px', background:'#1a1a1a', borderRadius:6 }}>
            Shows orders after payment confirmed
          </div>
        </div>
        <div style={{ display:'flex', gap:20, alignItems:'center' }}>
          <div style={{ textAlign:'center' }}><div style={{ fontSize:22, fontWeight:700, color:'#f5a623' }}>{active}</div><div style={{ fontSize:11, color:'#666' }}>ACTIVE</div></div>
          <div style={{ textAlign:'center' }}><div style={{ fontSize:22, fontWeight:700, color:'#4caf7d' }}>{cols.READY.length}</div><div style={{ fontSize:11, color:'#666' }}>READY</div></div>
          <div style={{ fontSize:20, fontWeight:700, color:'#888' }}>{clock.toLocaleTimeString('en',{hour:'2-digit',minute:'2-digit',second:'2-digit'})}</div>
        </div>
      </div>

      {/* Columns */}
      <div style={{ flex:1, display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:14, padding:14, overflowY:'auto' }}>
        {[
          ['PENDING',   '🔴 NEW ORDERS',    '#f5a623', 'Waiting for paid orders...'],
          ['PREPARING', '🟢 COOKING',       '#4caf7d', 'Nothing cooking'],
          ['READY',     '🔵 READY PICKUP',  '#5a9fe0', 'No orders ready'],
        ].map(([status, label, color, emptyMsg]) => (
          <div key={status}>
            <div style={{ fontSize:12, fontWeight:700, letterSpacing:1, color, marginBottom:10, display:'flex', alignItems:'center', gap:8 }}>
              {label}
              <span style={{ background:color, color:'#000', fontSize:11, fontWeight:700, padding:'2px 7px', borderRadius:20 }}>{cols[status].length}</span>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {cols[status].map((o) => <OrderCard key={o.id} order={o} onAdvance={advance} />)}
              {cols[status].length === 0 && (
                <div style={{ color:'#333', textAlign:'center', padding:32, fontSize:13 }}>{emptyMsg}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
